import React from 'react';

import { PrimaryLink } from '../../components/Common/Links';
import RichTextConverter from '../../components/Common/RichText/RichTextConverter';
import PageSection from '../../components/PageSections/PageSection';

export const ContentfulComponentSimpleContent = (section, i, styles) => {
  if (section.splitTitleAndBody) {
    return (
      <PageSection key={i} slim data-analytics-component={'simple-content'} data-analytics-id={section.title}>
        <div className={styles.simpleHalf}>
          <h2>{section.title}</h2>
          {section.body && <RichTextConverter copy={section.body} />}
        </div>
      </PageSection>
    );
  }
  return (
    <PageSection
      key={i}
      slim
      wide
      fullBleed
      className={section.textJustification === 'Left' ? styles.leftJustify : styles.centered}
      data-analytics-component={'simple-content'}
      data-analytics-id={section.title}
    >
      <h2>{section.title}</h2>
      {section.body && <RichTextConverter copy={section.body} />}
      {section.linkUrl && section.linkLabel && <PrimaryLink isButton label={section.linkLabel} url={section.linkUrl} />}
    </PageSection>
  );
};
